import { render, staticRenderFns } from "./AccountAccessModal.vue?vue&type=template&id=663140d1"
import script from "./AccountAccessModal.vue?vue&type=script&lang=js"
export * from "./AccountAccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports